import React from 'react';
import PropTypes from 'prop-types';

const Close = ({ fill = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5949 3.4125C14.5127 3.33018 14.4151 3.26488 14.3076 3.22032C14.2002 3.17576 14.085 3.15283 13.9687 3.15283C13.8523 3.15283 13.7371 3.17576 13.6297 3.22032C13.5222 3.26488 13.4246 3.33018 13.3424 3.4125L8.99991 7.7475L4.65741 3.405C4.57517 3.32276 4.47754 3.25752 4.37008 3.21302C4.26263 3.16851 4.14746 3.1456 4.03116 3.1456C3.91485 3.1456 3.79969 3.16851 3.69223 3.21302C3.58478 3.25752 3.48715 3.32276 3.40491 3.405C3.23882 3.57109 3.14551 3.79636 3.14551 4.03125C3.14551 4.26614 3.23882 4.49141 3.40491 4.6575L7.74741 9L3.40491 13.3425C3.23882 13.5086 3.14551 13.7339 3.14551 13.9688C3.14551 14.2036 3.23882 14.4289 3.40491 14.595C3.571 14.7611 3.79627 14.8544 4.03116 14.8544C4.26605 14.8544 4.49132 14.7611 4.65741 14.595L8.99991 10.2525L13.3424 14.595C13.5085 14.7611 13.7338 14.8544 13.9687 14.8544C14.2035 14.8544 14.4288 14.7611 14.5949 14.595C14.761 14.4289 14.8543 14.2036 14.8543 13.9688C14.8543 13.7339 14.761 13.5086 14.5949 13.3425L10.2524 9L14.5949 4.6575C14.7571 4.49087 14.8478 4.26753 14.8478 4.035C14.8478 3.80247 14.7571 3.57913 14.5949 3.4125Z"
      fill={fill || 'var(--SECONDARY_DARK)'}
    />
  </svg>
);

Close.propTypes = {
  fill: PropTypes.string,
};

export default Close;
